document.addEventListener('DOMContentLoaded', () => {
  const root = window.Shopify?.routes?.root || '/';

  let inFlight = false;

  const hideMsgs = () => {
    const errorMsg = document.getElementById('discount-code-error');
    if (errorMsg) errorMsg.hidden = true;
  };

  const setMsg = (el, msg) => {
    el.textContent = msg;
    el.hidden = false;
  };

  const disableForm = (locked) => {
    const input = document.getElementById('discount-code-input');
    const form = document.getElementById('cart-discount-form');
    if (!input || !form) return;

    input.disabled = locked;
    form.classList.toggle('discount-form--locked', locked);
    if (locked) {
      input.setAttribute('aria-disabled', 'true');
    } else {
      input.removeAttribute('aria-disabled');
    }
  };

  const showPill = (code) => {
    const input = document.getElementById('discount-code-input');
    const removeBtn = document.getElementById('discount-remove-btn');
    if (!input || !removeBtn) return;

    input.value = code;
    // Bloqueo visual y funcional como ya haces
    disableForm(true);

    // Mostramos el botón ✕ para poder eliminar el cupón
    removeBtn.hidden = false;
    removeBtn.disabled = false;
  };

  const hidePill = () => {
    const input = document.getElementById('discount-code-input');
    const removeBtn = document.getElementById('discount-remove-btn');
    if (!input || !removeBtn) return;

    input.value = '';
    // Desbloqueo visual y funcional como ya haces
    disableForm(false);

    // Ocultamos el botón ✕
    removeBtn.hidden = true;
    removeBtn.disabled = true;
  };

  const fetchCart = async () => {
    const res = await fetch(`${root}cart.js`);
    if (!res.ok) throw new Error('No se pudo obtener el carrito');
    return await res.json();
  };

  const applyDiscount = async (code) => {
    const res = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: code })
    });

    if (!res.ok) throw new Error('Error al aplicar descuento');
    return await fetchCart();
  };

  const clearDiscount = async () => {
    const res = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: '' })
    });

    if (!res.ok) throw new Error('Error al eliminar descuento');
    return await fetchCart();
  };

  const getAppliedDiscount = (cart, targetCode = null) => {
    const cartDiscounts = cart.cart_level_discount_applications || [];
    for (const d of cartDiscounts) {
      if (!targetCode || d.title?.toLowerCase() === targetCode.toLowerCase()) {
        return d.title || 'Cupón aplicado';
      }
    }

    for (const item of cart.items || []) {
      for (const d of item.discounts || []) {
        if (!targetCode || d.title?.toLowerCase() === targetCode.toLowerCase()) {
          return d.title || 'Descuento en producto';
        }
      }
    }

    if (targetCode) {
      const lowerCode = targetCode.toLowerCase();
      const allTitles = [
        ...cartDiscounts.map(d => d.title?.toLowerCase()),
        ...cart.items.flatMap(i => (i.discounts || []).map(d => d.title?.toLowerCase()))
      ].filter(Boolean);

      if (allTitles.includes(lowerCode)) {
        return targetCode;
      }
    }

    return null;
  };

  const refreshCartSections = async () => {
    const itemsWrap = document.querySelector('#main-cart-items');
    const footerWrap = document.querySelector('#main-cart-footer');
    const itemsSectionId = itemsWrap?.dataset?.id;
    const footerSectionId = footerWrap?.dataset?.id;

    if (!itemsSectionId && !footerSectionId) return;

    const requests = [];
    if (itemsSectionId) requests.push(fetch(`${root}cart?section_id=${itemsSectionId}`, { credentials: 'same-origin' }));
    if (footerSectionId) requests.push(fetch(`${root}cart?section_id=${footerSectionId}`, { credentials: 'same-origin' }));

    const responses = await Promise.all(requests.map(async (r) => {
      const res = await r;
      return res.ok ? res.text() : null;
    }));

    let idx = 0;

    if (itemsSectionId) {
      const html = responses[idx++];
      if (html) {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const next = temp.querySelector(`#main-cart-items[data-id="${itemsSectionId}"] .js-contents`);
        const cur = document.querySelector(`#main-cart-items[data-id="${itemsSectionId}"] .js-contents`);
        if (next && cur) cur.replaceWith(next);
      }
    }

    if (footerSectionId) {
      const html = responses[idx++];
      if (html) {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const next = temp.querySelector(`#main-cart-footer[data-id="${footerSectionId}"] .js-contents`) ||
                     temp.querySelector(`#main-cart-footer[data-id="${footerSectionId}"]`);
        const cur = document.querySelector(`#main-cart-footer[data-id="${footerSectionId}"] .js-contents`) ||
                    document.querySelector(`#main-cart-footer[data-id="${footerSectionId}"]`);
        if (next && cur) cur.replaceWith(next);
      }
    }

    await handleInitialState();
    bindDiscountListeners();
  };

  const handleInitialState = async () => {
    try {
      const cart = await fetchCart();
      const applied = getAppliedDiscount(cart);
      if (applied) {
        showPill(applied);
      } else {
        hidePill();
      }
    } catch (err) {
      console.warn('Error al obtener estado del carrito:', err);
    }
  };

  const handleApply = async (e) => {
    e.preventDefault();
    if (inFlight) return;

    hideMsgs();

    const input = document.getElementById('discount-code-input');
    const errorMsg = document.getElementById('discount-code-error');

    const code = input?.value?.trim();
    if (!code) {
      setMsg(errorMsg, 'Introduce un código válido.');
      input.setAttribute('aria-invalid', 'true');
      return;
    }

    inFlight = true;
    try {
      const cart = await applyDiscount(code);
      const applied = getAppliedDiscount(cart, code);

      if (applied && applied.toLowerCase() === code.toLowerCase()) {
        await refreshCartSections();
      } else {
        setMsg(errorMsg, 'El código no es válido o no se puede aplicar.');
        disableForm(false);
      }
    } catch (err) {
      setMsg(errorMsg, err.message || 'No se pudo aplicar el descuento');
      disableForm(false);
    } finally {
      inFlight = false;
    }
  };

  const handleRemove = async () => {
    if (inFlight) return;

    hideMsgs();
    inFlight = true;
    const errorMsg = document.getElementById('discount-code-error');
    const pillRemove = document.getElementById('discount-remove-btn');
    if (pillRemove) pillRemove.disabled = true;

    try {
      const cart = await clearDiscount();
      const applied = getAppliedDiscount(cart);

      if (!applied) {
        await refreshCartSections();
      } else {
        setMsg(errorMsg, 'Este descuento no puede eliminarse desde el carrito.');
        if (pillRemove) pillRemove.disabled = false;
      }
    } catch (err) {
      setMsg(errorMsg, err.message || 'No se pudo eliminar el descuento');
      if (pillRemove) pillRemove.disabled = false;
    } finally {
      inFlight = false;
    }
  };

  const bindDiscountListeners = () => {
    const form = document.getElementById('cart-discount-form');
    const input = document.getElementById('discount-code-input');
    const pillRemove = document.getElementById('discount-remove-btn');

    if (form) {
      form.addEventListener('submit', handleApply);
    }

    if (pillRemove) {
      pillRemove.addEventListener('click', handleRemove);
    }

    if (input) {
      input.addEventListener('input', () => {
        input.removeAttribute('aria-invalid');
        hideMsgs();
      });
    }
  };

  handleInitialState().then(bindDiscountListeners);
});
